import { createSelector } from 'reselect';
import { getScopes } from './getScopes';
export const getHasEmailSendingDomainAccess = createSelector(getScopes, scopes => scopes.includes('email-sending-domains-access'));